import { camelcaseKeys } from 'src/utils/camelize-keys';
import { timestampToDate } from 'src/utils/dateFormatter';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { PaymentMethod } from './_types';

const readOnlyFields = ['created_at', 'updated_at'];

export function normalizePaymentMethod(paymentMethod: any): PaymentMethod {
  const camelized = camelcaseKeys(paymentMethod, { deep: true });

  return {
    ...camelized,
    ...(camelized.createdAt && {
      createdAt: timestampToDate(camelized.createdAt),
    }),
    ...(camelized.updatedAt && {
      updatedAt: timestampToDate(camelized.updatedAt),
    }),
  } as PaymentMethod;
}

export function denormalizePaymentMethod(
  paymentMethod: Partial<PaymentMethod>
): any {
  const decamelized = decamelizeKeys(paymentMethod, { deep: true });

  removeReadOnlyFields(decamelized, readOnlyFields);

  return decamelized;
}

